var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"w-full"},[_c('header-register',{attrs:{"showButtonView":false}},[_vm._v(_vm._s(_vm.$t("sectionAdmCartoes.cardAdministrator"))+" ")]),_c('main',{staticClass:"mt-3"},[_c('ViewCard')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }